import Env from '../base/env';
import { module } from 'modujs';
import { RevealFadeOut } from '../fx/Common';
import gsap from 'gsap';

export default class extends module {
  init() {
    this.DOM = {};
    this.DOM.view = this.el;

    //? Fns
    gsap.delayedCall(Env.timingDelayFx, () => {
      RevealFadeOut(this.DOM.view);
    });
  }
}
